const PRESETS_KEY = "firestoreAdmin.explorer.presets.v1";
const COLUMNS_KEY = "firestoreAdmin.explorer.columns.v1";

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage full or unavailable */
  }
}

/* ------------------------------------------------------------------ */
/* Filter presets (per collection)                                     */
/* ------------------------------------------------------------------ */

/**
 * A preset captures the full filter state so it can be re-applied later.
 * shape: { globalSearch, filters, attendance }
 */
export function listPresets(collectionName) {
  const all = readJson(PRESETS_KEY, {});
  return Array.isArray(all[collectionName]) ? all[collectionName] : [];
}

export function savePreset(collectionName, name, state) {
  const all = readJson(PRESETS_KEY, {});
  const list = Array.isArray(all[collectionName]) ? all[collectionName] : [];
  const preset = {
    id: `preset_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    name: String(name || "Untitled").trim() || "Untitled",
    state,
    createdAt: new Date().toISOString(),
  };
  all[collectionName] = [preset, ...list];
  writeJson(PRESETS_KEY, all);
  return preset;
}

export function deletePreset(collectionName, id) {
  const all = readJson(PRESETS_KEY, {});
  const list = Array.isArray(all[collectionName]) ? all[collectionName] : [];
  all[collectionName] = list.filter((p) => p.id !== id);
  writeJson(PRESETS_KEY, all);
  return all[collectionName];
}

/* ------------------------------------------------------------------ */
/* Column preferences (per collection)                                 */
/* ------------------------------------------------------------------ */

/**
 * shape: {
 *   order: string[],           // field order
 *   hidden: Record<string,bool>,
 *   widths: Record<string,number>,
 *   pinnedLeft: string[],
 *   pinnedRight: string[],
 *   density: 'compact'|'standard'|'comfortable'
 * }
 */
export function loadColumnPrefs(collectionName) {
  const all = readJson(COLUMNS_KEY, {});
  return all[collectionName] || null;
}

export function saveColumnPrefs(collectionName, prefs) {
  if (!collectionName) return;
  const all = readJson(COLUMNS_KEY, {});
  all[collectionName] = prefs;
  writeJson(COLUMNS_KEY, all);
}

export function clearColumnPrefs(collectionName) {
  const all = readJson(COLUMNS_KEY, {});
  delete all[collectionName];
  writeJson(COLUMNS_KEY, all);
}

export function clearAllExplorerPrefs() {
  writeJson(PRESETS_KEY, {});
  writeJson(COLUMNS_KEY, {});
}
